export const ADDBLOGS = "addblogs";
export const DELETEBLOGS = "deleteblogs";
export const SEARCHING = "searching";
